export default {"src":"/_next/static/media/StrabismusandAmblyopia.1ca56a97.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};